import * as React from "react";
import {Datagrid, DateField, List, TextField, TextInput} from 'react-admin';

const noticeFilters = [
    <TextInput source="title" label={"Cím"} name={"title"} fullWidth required/>,
    <TextInput source="content" label={"Tartalom"} name={"content"} fullWidth required/>,
];

export const NoticeList = () => (
    <List title={'Push üzenetek'}
          sort={{field: 'createdAt', order: 'DESC'}}
          filters={noticeFilters}
          exporter={false}
    >
        <Datagrid rowClick={'show'} bulkActionButtons={false}>
            <TextField source="id" label={"ID"}/>
            <TextField source="title" label={"Cím"}/>
            <TextField source="content" label={"Tartalom"}/>
            <DateField source="createdAt" locales={['hu-HU']} label={"Létrehozva"}/>
        </Datagrid>
    </List>
);
